module.exports = __webpack_public_path__ + "media/greenhouse-hd06.39054b49.mp4";